import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import UserContext from '../tools/contextLib';
import 'bootstrap/dist/css/bootstrap.min.css';
import { browserName, browserVersion } from 'react-device-detect';
import axios from 'axios';
import { Table, Button, Form, FormGroup, Input, Label } from 'reactstrap';
import moment from 'moment';
import { connect } from 'react-redux';

class CipCode extends Component {
    static displayName = CipCode.name;

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            returnable: this.props.reduxData.userInfo,
            browser: `${browserName}${browserVersion}`,
            ip: "",
            globalLevel: "",
            permissionFlag: true,
            cipCodes: [",", "."],
            degrees: [",", "."],
            majors: [",", "."],
            editPKList: []
        }
        this.testPermission();
    }

    async getData() {
        const response = await axios.get('https://geolocation-db.com/json/');
        this.setState({
            ip: response.data.IPv4
        });
        this.getUserInfo();
    }

    async getUserInfo() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        //const response = await fetch('user', { method: 'GET', headers: { 'Authorization': bearerVAR } });
        //const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            returnable: this.props.reduxData.userInfo,
            loading: false,
            username: this.props.reduxData.userInfo.username,
        });
        this.setState({
            level: this.props.ourLevel
        });
        var dept = this.props.reduxData.userInfo.level.pk
        //this.recordComingHere();
        this.testPermission();
    }

    //async recordComingHere() {
    //    let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
    //    let toSend = {
    //        pagePK: "1027",
    //        department: this.props.reduxData.userInfo.level.pk,
    //        userPCID: this.props.reduxData.userInfo.pcid,
    //        ip: this.state.ip,
    //        browser: this.state.browser,
    //        userID: this.props.reduxData.userInfo.username
    //    }
    //    const response = await fetch('logging', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR  },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();
    //    localStorage.setItem("lastFetch", moment());
    //}

    async testPermission() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            pagepk: "1027"
        }
        const response = await fetch('ValidDepartments', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            permissionFlag: data
        })
        this.getCipCodes();
        this.getDegrees();
        this.getMajors();
    }

    async getCipCodes() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk
        }
        const response = await fetch('CipCodes', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            cipCodes: data
        })
    }

    async getDegrees() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk
        }
        const response = await fetch('CipDegree', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            degrees: data
        })
    }

    async getMajors() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk
        }
        const response = await fetch('CipMajor', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            majors: data
        })
    }

    componentDidMount() {

    }

    async addCip(e) {
        e.preventDefault();
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        const dataInput = new FormData(e.target);
        if (dataInput.get('maj') == "" || dataInput.get('hcode') == "" || dataInput.get('cip') == "") {
            return;
        }
        else {
            let toSend = {
                userLevel: this.props.reduxData.userInfo.level.pk,
                major: dataInput.get('maj'),
                currcode: dataInput.get('hcode'),
                cipcode: dataInput.get('cip'),
                mhec: dataInput.get('mhec')
            }
            //console.log("posting: " + JSON.stringify(toSend));
            const response = await fetch('AddCip', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
                body: JSON.stringify(toSend)
            })
            const data = await response.json();
            
            this.getCipCodes();
        }
        //localStorage.setItem("lastFetch", moment());
    }

    textboxOn(pk) {
        if (this.state.editPKList.indexOf(pk) <= -1) {
            //console.log("adding pk: " + pk);
            this.setState(prevState => ({
                editPKList: [...prevState.editPKList, pk]
            }))
        }
        else {
            //console.log("removing pk: " + pk);
            let currList = this.state.editPKList
            let index = currList.indexOf(pk)
            currList.splice(index, 1);
            this.setState({
                editPKList: currList
            })
            //this.updateExpDate(pk, "update", e.target.value);
        }
    }

    async updateCip(code, pk, e) {
        e.preventDefault();
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        //const dataInput = new FormData(e.target);
        //console.log("cip change: " + code + ", " + pk + ", " + e.target.value);
        if (code != e.target.value) {
            let toSend = {
                userLevel: this.props.reduxData.userInfo.level.pk,
                targetpk: pk,
                newcode: e.target.value,
                fieldtochange: "CIP_Code"
            }
            const response = await fetch('UpdateCodesCIP', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
                body: JSON.stringify(toSend)
            })
            const data = await response.json();
            //localStorage.setItem("lastFetch", moment());
            this.getCipCodes();
        }
    }

    async updateMHEC(code, pk, e) {
        e.preventDefault();
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        //const dataInput = new FormData(e.target);
        //console.log("mhec change: " + code + ", " + pk + ", " + e.target.value);
        if (code != e.target.value) {
            let toSend = {
                userLevel: this.props.reduxData.userInfo.level.pk,
                targetpk: pk,
                newcode: e.target.value,
                fieldtochange: "MHEC_CODE"
            }
            const response = await fetch('UpdateCodesCIP', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
                body: JSON.stringify(toSend)
            })
            const data = await response.json();
            //localStorage.setItem("lastFetch", moment());
            this.getCipCodes();
        }
    }

    /*
     * <td><div style={{ visibility: this.state.editPKList.indexOf(code.codepk) <= -1 ? 'visible' : 'hidden' }}> {code.cipcode}</div>
                                                <div style={{ visibility: this.state.editPKList.indexOf(code.codepk) > -1 ? 'visible' : 'hidden' }}>
                                                    
                                                </div>
                                            </td>
                                            <td><div style={{ visibility: this.state.editPKList.indexOf(code.codepk) <= -1 ? 'visible' : 'hidden' }}>{code.mhec}</div>
                                                <div style={{ visibility: this.state.editPKList.indexOf(code.codepk) > -1 ? 'visible' : 'hidden' }}>
                                                    <Form className='d-flex' onSubmit={(e) => this.updateCodes(code.codepk, e)}>
                                                        <Input type="text" name="newcip" id="newcip" placeholder={code.cipcode} />
                                                        <Input type="number" name="newmhec" id="newmhec" placeholder={code.mhec} />
                                                        <Button type="submit" outline color="success">Post</Button>
                                                    </Form>
                                                </div>
                                            </td>
                                            <td><Button outline color="warning" onClick={(e) => this.textboxOn(code.codepk, e)}>Edit</Button></td>
                                            */

    render() {
        if (this.state.permissionFlag == false) {
            this.props.passNewPage(-1);
        }
        //if (this.props.justSwitch == true) {
        //    this.props.passNewPage(1);
        //}
        //else {
            return (
                <UserContext.Consumer>
                    {contextData => (
                        <div>
                            <Form className="d-flex" onSubmit={this.addCip.bind(this) }>
                                <FormGroup> {/*Degree, Hood Code, CIP Code, MHEC Code (optional). Major can be derived from Hood Code*/}
                                    <Label>Major</Label>
                                    <Input type="select" name="maj" id="maj" defaultValue="DEFAULT">
                                        <option value="DEFAULT" disabled={true}>Select...</option>
                                        {this.state.degrees.map(degree => (
                                            <option value={degree.degcode}>{degree.degcode}</option>
                                            ))}
                                    </Input>
                                </FormGroup>
                                &nbsp;
                                <FormGroup>
                                    <Label>Hood Code</Label>
                                    <Input type="select" name="hcode" id="hcode" defaultValue="DEFAULT">
                                        <option value="DEFAULT" disabled={true}>Select...</option>
                                        {this.state.majors.map(maj => (
                                            <option value={maj.majorcode}>{maj.majorcode}</option>
                                            ))}
                                    </Input>
                                </FormGroup>
                                &nbsp;
                                <FormGroup>
                                    <Label>CIP Code</Label>
                                    <Input type="text" name="cip" id="cip">
                                    </Input>
                                </FormGroup>
                                &nbsp;
                                <FormGroup>
                                    <Label>MHEC Code (if available)</Label>
                                    <Input type="number" name="mhec" id="mhec" />
                                </FormGroup>
                                &emsp;
                                <Button outline color="success" type="submit">Submit</Button>
                            </Form>
                            <Table>
                                <thead>
                                <tr>
                                    <th>PK</th>
                                    <th>Degree</th>
                                    <th>Major</th>
                                    <th>Hood Code</th>
                                    <th>CIP Code</th>
                                    <th>MHEC Code (if available)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.cipCodes.map(code => (
                                        <tr>
                                            <td>{code.codepk}</td>
                                            <td>{code.degree}</td>
                                            <td>{code.major}</td>
                                            <td>{code.hoodcode}</td>
                                            <td><Input type="text" name="newcip" id="newcip" defaultValue={code.cipcode} onBlur={(e) => this.updateCip(code.cipcode, code.codepk, e)}/></td>
                                            <td><Input type="number" name="newmhec" id="newmhec" defaultValue={code.mhec} onBlur={(e) => this.updateMHEC(code.mhec, code.codepk, e)} /></td>
                                        </tr>
                                        ))}
                                </tbody>
                            </Table>
                        </div>
                    )}
                </UserContext.Consumer>
            );
        //}
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(CipCode);